export default "__VITE_ASSET__WWI1QnIs__"